import React from 'react';
import { Card, Button } from 'react-bootstrap';
import { BsGithub } from 'react-icons/bs';
import { CgWebsite } from 'react-icons/cg';
import './ProjectCards.css';

const ProjectCard = ({ isApp, title, description, ghLink, demoLink, index, viewMode }) => {
  const handleLinkClick = (url) => {
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <Card className="project-card theme-dark">
      <Card.Body className="project-card-body">
      <Card.Text className="project-title">
          {title}
        </Card.Text>
        
        <Card.Text className="project-description">
          {description.split('\n').map((line, index) => (
            <React.Fragment key={index}>
              {line}
              {index < description.split('\n').length - 1 && <br />}
            </React.Fragment>
          ))}
        </Card.Text>
        
        <div className="project-actions">
          {ghLink && (
            <Button
              variant="outline-primary"
              size="sm"
              className="action-btn github-btn"
              onClick={() => handleLinkClick(ghLink)}
            >
              <BsGithub /> GitHub
            </Button>
          )}
          
          {demoLink && (
            <Button
              variant="outline-success"
              size="sm"
              className="action-btn demo-btn"
              onClick={() => handleLinkClick(demoLink)}
            >
              <CgWebsite /> Demo
            </Button>
          )}
          
        </div>
      </Card.Body>
    </Card>
  );
};

export default ProjectCard;